var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('img',{staticClass:"about_icon",attrs:{"src":require("@/assets/2022/logo_nobackground.svg"),"alt":""}}),_c('div',{staticClass:"game_list_top"},[_c('GameList')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news_list_page_back_box"},[_c('img',{staticClass:"news_list_page_back",attrs:{"src":require("@/assets/2022/背景2_素材.svg"),"alt":""}})])
}]

export { render, staticRenderFns }